/**
 * Order invoices (MYP-124).
 *
 * `get_receipt_pdf_url` (the vendor's answer to Q&A v2 question 9) returns
 * `{code: "1", data: {orderno, pdfurl}}`, where `pdfurl` is a link on the vendor's own site that
 * downloads the order's receipt PDF. The app only ever hands the browser a link on that site.
 */

/** The only place an invoice link may point: the vendor's own site, over HTTPS. */
export const INVOICE_HOST = 'www.mypoz.com';

/**
 * The invoice link out of a `get_receipt_pdf_url` reply, or undefined when there is none the app
 * should follow — missing, not text, not a URL, not HTTPS, or on any other host. A link the app
 * does not recognise is treated as "no invoice" rather than opened: the browser would download
 * whatever it points at.
 */
export function invoiceUrlFrom(body: unknown): string | undefined {
  if (typeof body !== 'object' || body === null) return undefined;
  const data = (body as Record<string, unknown>)['data'];
  if (typeof data !== 'object' || data === null) return undefined;
  const raw = (data as Record<string, unknown>)['pdfurl'];
  if (typeof raw !== 'string' || raw.trim() === '') return undefined;

  let url: URL;
  try {
    url = new URL(raw.trim());
  } catch {
    return undefined;
  }
  if (url.protocol !== 'https:' || url.hostname !== INVOICE_HOST) return undefined;
  return url.toString();
}
